import { handleActions } from 'redux-actions';
import http from '../shared/http';
import intl from '../shared/intl';
import endpoints from '../../config/endpoints';

const DATA_FETCH_SUCCESS = 'discounts/data-fetch-success';
const DATA_FETCH_ERROR  = 'discounts/data-fetch-error';
import { LOCATION_CHANGE } from 'react-router-redux';

// initialState state
const initialState = {
	data: null,
	error: false
};

// actions
export const actions = {
	fetchData: () => (dispatch, getState) => {
		const request = http({
			url: `${endpoints.DISCOUNTS.LIST}`,
			method:'get',
			actions:[
				DATA_FETCH_SUCCESS,
				DATA_FETCH_ERROR
			]
		});
		request(dispatch);
	}
};

// reducers
const reducers = Object.assign({
	[LOCATION_CHANGE]: (state, action) => {
		return initialState;
	},
	[DATA_FETCH_SUCCESS]: (state, action) => ({
		...state,
		data: action.payload.data
	}),
	[DATA_FETCH_ERROR]: state => ({
		...state,
		error: true
	})
});

export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	getData: state => state.discounts && state.discounts.data,
	getUserData: state => state.app.userData,
	getManager: state => state.userApi.data && state.userApi.data.manager,
	getIntl: state => intl(state)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/discounts/index.js